<template lang="pug">
  #home
    .loader(v-if="isLoading")
      .block  
        .slide
          img(src="/assets/loader.gif")
          .progress
    .resize(v-if="notSupported && !isMobile" )
      img(src="/assets/resize.svg" v-if="!isIpad")
      img(src="/assets/turn_screen.svg" v-if="isIpad")
      p(v-if="!isIpad") Expande la ventana del navegador para tener una mejor experiencia
      p(v-if="isIpad") Gira la tableta horizontalmente para tener una mejor experiencia
    div(v-if="!isMobile")
      Intro
      Sections
    div(v-if="isMobile")
      //- Intro
      //- Sections
      MobileIntro
      MobileSections
    
</template>

<script>
import Intro from "@/components/Intro.vue";
import Sections from "@/components/Sections.vue";
import flipbook from "flipbook";
import MobileIntro from "@/components/Mobile/MobileIntro.vue";
import MobileSections from "@/components/Mobile/MobileSections.vue";

export default {
  name: "home",
  components: {
    Intro,
    Sections,
    MobileIntro,
    MobileSections
  },
  data() {
    return {
      isLoading: false,
      notSupported: false,
      isIpad: false,
      isMobile: true
    };
  },
  computed: {
    sectionId: {
      get() {
        return this.$store.state.sectionId;
      },
      set(value) {
        this.$store.state.sectionId = value;
      }
    },
    subsectionId: {
      get() {
        return this.$store.state.subsectionId;
      },
      set(value) {
        this.$store.state.subsectionId = value;
      }
    }
  },
  watch: {
    isLoading: function(value) {
      this.loader(value);
    }
  },
  methods: {
    mobileCheck() {
      var check = false;
      (function(a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw(n|u)|c55\/|capi|ccwa|cdm|cell|chtm|cldc|cmd|co(mp|nd)|craw|da(it|ll|ng)|dbte|dcs|devi|dica|dmob|do(c|p)o|ds(12|d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(|_)|g1 u|g560|gene|gf5|gmo|go(\.w|od)|gr(ad|un)|haie|hcit|hd(m|p|t)|hei|hi(pt|ta)|hp( i|ip)|hsc|ht(c(| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i(20|go|ma)|i230|iac( ||\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|[a-w])|libw|lynx|m1w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|mcr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|([1-8]|c))|phil|pire|pl(ay|uc)|pn2|po(ck|rt|se)|prox|psio|ptg|qaa|qc(07|12|21|32|60|[2-7]|i)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h|oo|p)|sdk\/|se(c(|0|1)|47|mc|nd|ri)|sgh|shar|sie(|m)|sk0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h|v|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl|tdg|tel(i|m)|tim|tmo|to(pl|sh)|ts(70|m|m3|m5)|tx9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c( | )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas|your|zeto|zte/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    },
    loader(loading) {
      if (loading) {
        document.body.classList.add("freeze");
      } else {
        setTimeout(() => {
          document.body.classList.remove("freeze");
        }, 700);
      }
    },
    async lazyLoadFlipbook(element) {
      if (!this.isMobile) {
        const animations = document.querySelectorAll(
          "#" +
            element.parentNode.parentNode.parentNode.parentNode.id +
            " .animation"
        );

        let kickOff = 1;
        let previous = 0;

        animations.forEach((a, index) => {
          if (a && a.classList.contains("init"))
            return a.classList.remove("init");
          if (
            a &&
            !a.classList.contains("active") &&
            !a.classList.contains("init")
          ) {
            this.isLoading = true;
            a.classList.add("active");
            flipbook({
              id: a.id,
              path: a.dataset.path,
              filename: "%1d",
              extension: "png",
              count: a.dataset.count,
              speed: a.dataset.speed,
              loaded: () => {
                if (kickOff == animations.length) this.isLoading = false;
                kickOff++;
              },
              progress: function(data) {
                const progressEl = document.getElementsByClassName(
                  "progress"
                )[0];
                let current = (data.percent * kickOff) / animations.length;
                //console.log(current, previous, data.percent, kickOff);
                progressEl.style.width =
                  (current >= previous ? current : previous) + "%";
                previous = previous > current ? previous : current;
              }
            });
          }
        });
      }
    },
    menuEffect(element) {
      if (this.isMobile) {
        this.sectionId = element.parentNode.parentNode.parentNode.parentNode.id;
        this.subsectionId = element.parentNode.parentNode.parentNode.id;
      } else {
        const allSubsections = document.querySelectorAll("a.sub.subtitle");
        allSubsections.forEach(sub => {
          sub.style.opacity = 0;
        });
        const sections = document.querySelectorAll(".nav-link");
        sections.forEach((s, i) => {
          s.classList.remove("active");
        });
        const subsectionId = element.parentNode.parentNode.parentNode.id;

        document
          .getElementsByClassName(subsectionId)[0]
          .parentNode.parentNode.classList.add("active");
        document.getElementsByClassName(subsectionId)[0].style.opacity = 1;
      }
    },
    headerObserver() {
      let previousY = 0;
      let previousRatio = 0;
      let currentY = window.scrollY;
      let options = {
        root: null,
        rootMargin: '0px',
        threshold: [0,1]
      }      
        let slideEffect = (entries, observer) => { 
        entries.forEach(entry => {         

          previousY = currentY;
          currentY = window.scrollY;
          const scrollingDown = currentY > previousY,
            elementExits =
              !entry.isIntersecting && entry.intersectionRatio == 0,
            text = document.querySelector(
              "#" + entry.target.parentNode.id + " .slide p"
            );

          if (scrollingDown) {
            if (entry.isIntersecting) {
              if (text) text.classList.remove("show");
              if (entry.intersectionRatio == 1) this.menuEffect(entry.target);
              this.lazyLoadFlipbook(entry.target);
            } else if (text) text.classList.add("show");
          } else if (text) {
            entry.isIntersecting || elementExits
              ? text.classList.remove("show")
              : text.classList.add("show");
          }
        });
      };
      let targets = document.querySelectorAll(".fake-header");
      let observer = new IntersectionObserver(slideEffect, options);
      targets.forEach(t => {
        observer.observe(t);
      });
    },
    footerObserver() {
      let previousY = 0;
      let currentY = window.scrollY;
      let options = {
        root: null,
        rootMargin: "0px",
        threshold: [0, 1]
      };
      let slideEffect = (entries, observer) => {
        entries.forEach(entry => {
          previousY = currentY;
          currentY = window.scrollY;
          const scrollingDown = currentY > previousY,
            elementExits =
              !entry.isIntersecting && entry.intersectionRatio == 0,
            text = document.querySelector(
              "#" + entry.target.parentNode.id + " .slide p"
            );

          if (scrollingDown && text) {
            entry.isIntersecting || elementExits
              ? text.classList.remove("show")
              : text.classList.add("show");
          } else if (!scrollingDown) {
            if (entry.isIntersecting) {
              if (text) text.classList.remove("show");
              if (entry.intersectionRatio == 1) this.menuEffect(entry.target);
              this.lazyLoadFlipbook(entry.target);
            } else if (text) text.classList.add("show");
          }
        });
      };

      let targets = document.querySelectorAll(".fake-footer");
      let observer = new IntersectionObserver(slideEffect, options);
      targets.forEach(t => {
        observer.observe(t);
      });
    },
    checkWindowSupport() {
      this.notSupported = window.innerWidth < 769 || window.innerHeight < 576 || window.innerWidth < window.innerHeight * 1.3;
      this.notSupported ? document.querySelector('#landing .logoHeader').classList.add('fixed') : document.querySelector('#landing .logoHeader').classList.remove('fixed');
      this.notSupported ? document.querySelector('#landing .logoHeader').classList.add('fixed') : document.querySelector('#landing .logoHeader').classList.remove('fixed');
      this.isIpad = navigator.userAgent.match(/iPad/i) != null;
    },
    clearText() {
      setTimeout(() => {
        document
          .querySelectorAll(".slide p")
          .forEach(p => p.classList.remove("show"));
      }, 1000);
    },
    async initialize() {
      await this.headerObserver();
      await this.footerObserver();
      this.clearText();
      this.checkWindowSupport();
      window.addEventListener("resize", () => {
        this.checkWindowSupport();
      });
    }
  },
  mounted() {
    this.initialize();
    this.isMobile = this.mobileCheck();
  }
};
</script>
<style lang="scss" scoped>
#home .loader {
  height: 100vh;
  background-color: #024133a8;
  position: fixed;
  top: 0;
  z-index: 30;
  width: 100%;
  .block {
    @include blockin(100%, 100%, 0%, 0%);
    z-index: 10;
    .slide {
      width: 100%;
      height: 100%;
      img {
        position: absolute;
        left: 47%;
        @include blockinImg(150px, 150px, 40%);
      }
      .progress {
        position: absolute;
        top: 66%;
        left: 0%;
        height: 6px;
      }
    }
  }
}

.resize {
  width: 100%;
  height: 100vh;
  background-color: #024133;
  z-index: 50;
  position: fixed;
  top: 0;
  img {
    position: fixed;
    top: 30%;
    left: 40%;
    max-width: 180px;
    max-height: 180px;
  }
  p {
    font-size: 1rem;
    width: 50%;
    left: 25%;
    top: 55%;
    position: fixed;
    font-weight: 600;
  }
}

@media (max-width: 420px) {
  #home .loader {
    .block {
      .slide {
        img {
          left: 30%;
          @include blockinImg(40vw, 150px, 35%);
        }
      }
    }
  }
}

@media (min-width: 421px) and (max-width: 991px) {
  #home .loader {
    .block {
      .slide {
        img {
          left: 44%;
          @include blockinImg(150px, 150px, 35%);
        }
      }
    }
  }
}
</style>
